module.exports = __webpack_public_path__ + "static/media/smithmicro-ui-design-PC-app.49fcf3a1.jpg";